module.exports = __webpack_public_path__ + "img/play.8f34e3e2.png";